import { gql } from '@apollo/client';

export const QUERY_CYCLE_BILLING_RESULTS = gql`
  query QueryCycleBillingResults($trackingNos: [String!]!) {
    queryCycleBillingResults(trackingNos: $trackingNos) {
      id
      trackingNo
      businessLine
      scenarioCode
      factorType
      usageStatus
      changeType
    }
  }
`;

export const QUERY_SETTLEMENT_ORDERS = gql`
  query QuerySettlementOrders($businessIds: [String!]!) {
    querySettlementOrders(businessIds: $businessIds) {
      orderId
      trackingNo
      overallStatus
      channelId
      dspId
      orderSort
      dspAmount
      dspDiscountAmount
      feePrime
      groupId
      groupSort
      taskDate
      deliveredAt
    }
  }
`;
